@if (userName() && !isCompact()) {
<button mat-stroked-button [matTooltip]="'userButton.logoutTooltip' | translate" (click)="logout()">
    <mat-icon>account_circle</mat-icon>
    <span>{{userName()}}</span>
</button>
} @else {
<button mat-icon-button [matTooltip]="'userButton.logoutTooltip' | translate" (click)="logout()">
    <mat-icon>account_circle</mat-icon>
</button>
}